import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// "ETHUSDT" -> "ETH", "BTCUSD" -> "BTC". Used to label balances/qty generically
// now that the traded pair is selectable (no more hardcoded "BTC" in the UI).
export function baseAsset(symbol) {
  const s = String(symbol || "BTCUSDT").toUpperCase();
  for (const q of ["USDT", "USDC", "BUSD", "USD"]) {
    if (s.endsWith(q) && s.length > q.length) return s.slice(0, -q.length);
  }
  return s;
}

// Adaptive price decimals: BTC wants 0-2, a $0.02 token wants 6.
export function priceDecimals(p) {
  const v = Math.abs(Number(p) || 0);
  if (v >= 1000) return 2;
  if (v >= 10) return 2;
  if (v >= 0.1) return 4;
  return 6;
}
